interface IStrongBoxOrderListingBase {
    id: number,
    internalTrackingNumber: string,
    vendorOrderId: string,
    quantity: number,
    status: number,
    statusDescription: string,
    vendorStatus: string,
    statusDate?: Date,
    createdByUserId: number,
    createdDate: Date,
    updatedByUserId: number,
    updatedDate: Date,
    notes?: string,
    swapInfo: IStrongBoxSwapInfo
}

export interface IStrongBoxCenterOrderListing extends IStrongBoxOrderListingBase {
    centerId: number,
    centerAlias: string,
}

export interface IStrongBoxOpoOrderListing extends IStrongBoxOrderListingBase {
    opoId: number,
    opoName: string,
}

export interface IStrongBoxSwapInfo {
    id: number,
    compositeSwapNumber: string,
    donorCenter: string
    remoteDonorCenter: string,
    recipientCenter: string,
    kidneyPickupDate: Date,
    isSwapCancelled: boolean
}

interface IStrongBoxOrderBase {
    quantity: number,
    clusterId?: number,
    swapPosition?: number,
    notes?: string,
    createdDate?: Date
    updatedDate?: Date
}

export interface IStrongBoxOrderContract extends IStrongBoxOrderBase {
    centerId: number,   
}

export interface IStrongBoxOpoOrderContract  extends IStrongBoxOrderBase{
    opoId: number,
}